export default "__VITE_ASSET__DnEwHLln__"